import { makeEntityScaffold } from '@classpass/saga-tools';
export var achievementsPastReservations = makeEntityScaffold('SAGA.API.ACHIEVEMENTS_PAST_RESERVATIONS', function (client) {
  return client.achievements.pastReservations().then(function (data) {
    return data;
  });
});
export var achievementsPastReservationsCount = makeEntityScaffold('SAGA.API.ACHIEVEMENTS_PAST_RESERVATIONS_COUNT', function (client) {
  return client.achievements.pastReservationsMeta().then(function (data) {
    return data;
  });
});